// removed by extract-text-webpack-plugin
module.exports = {"formAreaContain":"ZPm8aW1ANTLVA5FaDqxhp","choreTitle":"_12XJ7Y0ouSpnWz0OIV0X0g","pointContain":"_2NQLuFrJ4eW79PUijntqZE","weekContain":"-gC-Dnvb-SKxWjc6N57Mr","pointField":"v8HZCZ4sEFWtY8P7SzuJ-","weekField":"_2lvmXu9jcvktKNfxEqYjCU","buttonBox":"_3in9SPM9--EWZ6yCnUNa_w","saveButton":"_1agrUNxmMlTG9kjqC21uo2","cancelButton":"_1l3m900qGU4sDlBIs-ee7Q","validate":"-xbwXnuOgOF5CINVNZ8UR","formBox":"_2JrxTd1X1ay2HO0XsHA_em"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/ChoreForm.css
// module id = 380
// module chunks = 0